export default __webpack_public_path__ + "static/media/login banner2.66ff45af.jpg";